<template>
	<VueDatePicker
		v-model="date"
		auto-apply
		:clearable="false"
		:enable-time-picker="false"
		:min-date="min"
		:max-date="max"
		model-type="yyyy-MM-dd"
		:text-input="true"
		format="dd.MM.yyyy"
		:locale="$i18n.locale"
		class="ao-great-date-picker ao-selector-of-date-range-picker"
		monthNameFormat="long"
		:placeholder="$t('dd.mm.yyyy')"
	/>
</template>

<script setup>
import { computed } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'

const props = defineProps({

	modelValue: {
		type: String,
		default: () => (null),
	},

	min: {
		type: String,
	},

	max: {
		type: String,
	},

	debugMode: {
		type: Boolean,
		default: false,
	},

})

const emit = defineEmits({
	'update:modelValue': null,
})

const date = computed({
	get: () => {
		return props.modelValue
	},
	set: (value) => {
		if (props.debugMode) {
			// eslint-disable-next-line no-console
			console.log('date', value)
		}
		emit('update:modelValue', value)
	},
})
</script>

<style lang="scss">
.ao-selector-of-date-range-picker {

	.dp__input_wrap {

		.dp__input {
			width: 86px;
			border: none;
			border-bottom: 1px solid rgba(0, 0, 0, 0.36);
			border-radius: 0;
			padding: 2px 4px;
			font-size: 12px;
			font-weight: 400;
			line-height: 18px;
			// min-height: unset;
		}

		svg {
			display: none;
		}

	}

}
</style>
